import { escapeRegExp } from 'lodash-es';

export const MAX_IMPORT_FILE_SIZE = 1024 * 1024;

export const PUBLIC_KEY_ACCEPT = '.pub,.txt';

export const OPENSSH_KEY_PREFIXES = [
    'ssh-rsa',
    'ssh-dss',
    'ssh-ed25519',
    'ecdsa-sha2-nistp256',
    'ecdsa-sha2-nistp384',
    'ecdsa-sha2-nistp521',
    'sk-ecdsa-sha2-nistp256@openssh.com',
    'sk-ssh-ed25519@openssh.com',
] as const;

// Matches every PEM private key label - PKCS#8, RSA, EC, DSA, OPENSSH and ENCRYPTED alike.
const PRIVATE_KEY_BLOCK = /-----BEGIN (?:[A-Z0-9]+ )*PRIVATE KEY-----[\s\S]*?-----END (?:[A-Z0-9]+ )*PRIVATE KEY-----/;

const PUBLIC_KEY_LINE = new RegExp(`^(?:${OPENSSH_KEY_PREFIXES.map(escapeRegExp).join('|')})\\s+[A-Za-z0-9+/]+={0,3}(?:\\s.*)?$`);

const normalizeLineEndings = (text: string) => text.replace(/\r\n?/g, '\n');

export function extractPrivateKeyBlock(text: string) {
    return normalizeLineEndings(text).match(PRIVATE_KEY_BLOCK)?.[0] ?? null;
}

export function extractPublicKeyLine(text: string) {
    for (const line of normalizeLineEndings(text).split('\n')) {
        const candidate = line.trim();

        if (PUBLIC_KEY_LINE.test(candidate)) return candidate;
    }

    return null;
}
